export default __webpack_public_path__ + "static/media/bear_pic_5.149ef779.png";